import React from 'react';
import {Box, useMediaQuery, useTheme} from "@material-ui/core";
import gridImage1 from '../../../../resources/images/grid-image-1.png';
import gridImage2 from '../../../../resources/images/grid-image-2.png';
import useStyles from "./StopoverGridImagesStyles";
import {useSelector} from "react-redux";
import Slideshow from "../../../Common/Slideshow/Slideshow";

const StopoverGridImages = () => {

    const {breakpoints} = useTheme();
    const slideshowImages = useSelector(state => state.sw.book.stopover.slideshowImages);
    const slideshowImagesLoading = useSelector(state => state.sw.book.stopover.slideshowImagesLoading);
    const inboundSelectedAirport = useSelector(state => state.sw.book.stopover.inbound?.selectedAirport);
    const outboundSelectedAirport = useSelector(state => state.sw.book.stopover.outbound?.selectedAirport);
    const isTablet = useMediaQuery(breakpoints.down('md'));
    const isMobile = useMediaQuery(breakpoints.down('sm'));
    const classes = useStyles({isMobile, isTablet});

    const selectedAirportsStr = (inboundSelectedAirport || outboundSelectedAirport) ? `${outboundSelectedAirport}${inboundSelectedAirport}` : '';

    return (
        <Box display={'flex'} flexDirection={'column'} borderRadius={'6px'}>
            <Slideshow
                images={slideshowImages?.filter(i => i.slideshow === 'TOP' && Boolean(!selectedAirportsStr || !i.airport || selectedAirportsStr.includes(i.airport))).sort((a, b) => a.position.localeCompare(b.position))}
                className={classes.img1}
                loading={slideshowImagesLoading}
                defaultImage={gridImage1}
            />
            {!isTablet && (
                <Slideshow
                    images={slideshowImages?.filter(i => i.slideshow === 'BOTTOM' && Boolean(!selectedAirportsStr || !i.airport || selectedAirportsStr.includes(i.airport))).sort((a, b) => a.position.localeCompare(b.position))}
                    className={classes.img2}
                    loading={slideshowImagesLoading}
                    defaultImage={gridImage2}
                    startDelay={2500}
                />
            )}
        </Box>
    );
};

export default StopoverGridImages;
